// Type guard to narrow the union in UpdateApolloCache
export const isDiscriminatedProps = (props) => 'type' in props && Boolean(props.type);
